import injectSheet from 'react-jss'
import Icon from './Icon'
import styles from './Icon.styles'

export default injectSheet(styles)(Icon)
